import React from 'react';
import { Switch } from '@blueprintjs/core';
import FormTextGroup from 'components/forms/components/form-text-group';
import FormSelectGroup from 'components/forms/components/form-select-group';
import styled from 'styled-components';
import { FormSectionContainer as Container } from 'components/styled-components';

const SponsorSwitch = props => (
  <Switch
    name="sponsor"
    label="Change Sponsor"
    checked={props.showSponsors}
    onChange={() => {
      props.setFieldValue('sponsor.userID', props.appUser.userID);
      props.setFieldValue('sponsor.firstName', props.appUser.firstName);
      props.setFieldValue('sponsor.lastName', props.appUser.lastName);
      props.setFieldValue('sponsor.email', props.appUser.email);
      props.setFieldValue('sponsor.department', props.appUser.department);
      props.handleChangeSponsorClick(!props.showSponsors);
    }}
  />
);

const SponsorContainer = props => (
  <React.Fragment>
    <Wrapper>
      <FormTextGroup
        label="First Name"
        requiredLabel={true}
        class="medium-text-group"
        name="sponsor.firstName"
        value={props.values.sponsor.firstName}
        disabled={true}
      />
      <FormTextGroup
        label="Last Name"
        requiredLabel={true}
        class="medium-text-group"
        name="sponsor.lastName"
        value={props.values.sponsor.lastName}
        disabled={true}
      />
      <SponsorSwitch {...props} />
    </Wrapper>
    <FormTextGroup
      label="Email"
      requiredLabel={true}
      name="sponsor.email"
      value={props.values.sponsor.email}
      disabled={true}
    />
    <FormTextGroup
      label="Sponsor Department"
      requiredLabel={false}
      name="sponsor.department"
      value={props.values.sponsor.department}
      disabled={true}
    />
  </React.Fragment>
);

const SelectSponsor = props => (
  <React.Fragment>
    <Wrapper>
      <FormSelectGroup
        name="sponsor"
        label="Choose a sponsor"
        class="custom-text-group"
        value={props.values.sponsor}
        onChange={(_, value) => {
          props.setFieldValue('sponsor.userID', value.userID);
          props.setFieldValue('sponsor.firstName', value.firstName);
          props.setFieldValue('sponsor.lastName', value.lastName);
          props.setFieldValue('sponsor.department', value.department);
          props.setFieldValue('sponsor.email', value.email);
        }}
        onBlur={props.setFieldTouched}
        asyncOptions={props.sponsors}
        isClearable={false}
        labelKey="email"
        valueKey="userID"
        requiredLabel={true}
        noOptionsMessage="There were no sponsor users found in the system."
        {...props}
      />
      <SponsorSwitch {...props} />
    </Wrapper>
  </React.Fragment>
);

const SponsorFormSection = props => (
  <Container>
    {props.showSponsors ? (
      <SelectSponsor {...props} />
    ) : (
      <SponsorContainer {...props} />
    )}
    <FormSelectGroup
      label="Requesting Department"
      value={props.values.departmentsRequesting}
      onChange={props.setFieldValue}
      onBlur={props.setFieldTouched}
      name="departmentsRequesting"
      asyncOptions={props.departments}
      labelKey="departmentName"
      valueKey="departmentID"
      requiredLabel={true}
      multi={true}
      {...props}
    />
  </Container>
);

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
`;

export default SponsorFormSection;
